'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';

type Platform = 'android' | 'ios' | 'other';

interface Props {
  platform: Platform;
}

const PlatformContext = createContext<Props | undefined>(undefined);

export const PlatformProvider = ({ children }: React.PropsWithChildren) => {
  const [platform, setPlatform] = useState<Platform>('other');

  useEffect(() => {
    try {
      const ua = navigator.userAgent;

      const isIOS =
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      const isAndroid = /Android/.test(ua);

      const newPlatform: Platform = isIOS
        ? 'ios'
        : isAndroid
          ? 'android'
          : 'other';

      console.log('newPlatform', newPlatform);

      setPlatform(newPlatform);
    } catch (_e) {
      setPlatform('other');
    }
  }, []);

  return (
    <PlatformContext.Provider value={{ platform }}>
      {children}
    </PlatformContext.Provider>
  );
};

export const usePlatform = () => useContext(PlatformContext)!;
